export const SELF_VIDEO_ID = 'ZOOM_WEB_SDK_SELF_VIDEO';
